<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Grande acquirente' : 'Nuovo Grande acquirente' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-big-buyers-form [data]="data"></app-big-buyers-form>
</div>
